<!-- =========================================================================================
  File Name: DailyLogin.vue.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="vx-col  w-full mb-base">

  <vx-card ><label for="">From: </label>
    <flat-pickr placeholder="From Date" v-model="fromDate"  :config="configTodateTimePicker" format="MM/dd/yyyy"/>
    <label for=""> To: </label>
    <flat-pickr class="ml-1 from-control" :config="configTodateTimePicker" v-model="toDate" placeholder="To Date"
                format="MM/dd/yyyy"/>

    <vs-button color="primary" @click="getFilterReport()" class="ml-1 flex inline-flex" type="border"
               icon-pack="feather" icon="icon-search"></vs-button>
    <vue-apex-charts type="bar" :height="50 * fullname.length + 45"  :options="Fullname" :series="todayLogin"></vue-apex-charts>

  </vx-card>
    <br>
   <div class="vx-col  w-full mb-base">
      <vx-card title="Last Week at a Glance">
        <vue-apex-charts type="area" height="300" :options="weeklyData.chartOptions" :series="Series"></vue-apex-charts>
      </vx-card>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {GET_LOGIN_DATE_REPORT, GET_LOGIN_REPORT, GET_LOGIN_WEEK_REPORT} from '@/graphql'
import moment from 'moment'
import {colors} from '../../../themeConfig'

export default {
  components: {
  VueApexCharts,
  Datepicker,
  moment,
  flatPickr,
  },
  data () {
    return {
      DataNotFound: false,
      fromDate: null,
      toDate: null,
      fullname: [],
      todayLogin: [],
      WeekDates: [],
      WeekLoginCount: [],
      configFromdateTimePicker: {
        minDate: new Date(),
        maxDate: null
      },
      configTodateTimePicker: {
        minDate: null,
        dateFormat: 'm/d/Y',
      },

    }
  },
  computed: {
    Series() {
      return [{
        name: ' Logins# ',
        data: this.WeekLoginCount
      },
      ]
    },
    weeklyData() {
      return {
        colors: [colors.primary],
        series: [{
          name: 'Logins# ',
          data: this.WeekLoginCount
        },
        ],
        chartOptions: {
          dataLabels: {
            enabled: false
          },
          chart: {
            sparkline: {
              enabled: true
            },
          },
          stroke: {
            curve: 'smooth',
            colors: colors.primary,
          },
          fill: {
            type: 'solid',
            colors: colors.primary,
            opacity: [1],
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: function (value) {
                return value
              }
            },
          },
          xaxis: {

            categories: this.WeekDates
          },
          yaxis: {
            labels: {
              show: false,
            }
          },
        }
      }

    },
    Fullname() {
      return {
        colors: colors.primary,
        plotOptions: {
          bar: {
            horizontal: true,
          }
        },
           chart: {
            toolbar: {
              show: false
            },
          },
        tooltip: {
         enabled: true,
         y: {
         formatter: function(value) {
         return value
         }
         },
      },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
          categories: this.fullname,
          labels: {
          show: false,
          }
          },
      }
    },
    charthight(){
        return 50*this.fullname.length
    }

  },
  methods: {

    GetReport(date){
      this.$apollo
       .mutate({
          mutation: GET_LOGIN_REPORT,
           variables: {
            date: date,
          }
        }).then(response => {
          var todaylogin=[];
          var todayloginName=[];
         if(response) {
           if (response.data.getLoginReport.user == '') {
             todaylogin.push(0)
             todayloginName.push("Data Not Found")
             this.todayLogin = [{name: 'Logins# ', data:todaylogin}]
             this.fullname = todayloginName
           } else {
             for (let i = 0; i < response.data.getLoginReport.user.length; i++) {
               todaylogin.push(response.data.getLoginReport.user[i].login_counter)
               todayloginName.push(response.data.getLoginReport.user[i].users.fname + ' ' + response.data.getLoginReport.user[i].users.lname)
             }
             this.todayLogin = [{name: 'Logins# ', data:todaylogin}]
             this.fullname = todayloginName
           }

         }
        })
        .catch(error => {
        });
  },
  getFilterReport(){
    this.$apollo
       .mutate({
          mutation: GET_LOGIN_DATE_REPORT,
           variables: {
            fromDate: this.fromDate,
            toDate: this.toDate
          }
        }).then(response => {
          var todaylogin=[];
          var todayloginName=[];
         if(response) {
           if (response.data.getLoginDateReport.user == '') {
             todaylogin.push(0)
             todayloginName.push("Data Not Found")
             this.todayLogin = [{name: 'Logins#', data: todaylogin}]
             this.fullname = todayloginName
           } else {
             for (let i = 0; i < response.data.getLoginDateReport.user.length; i++) {
               todaylogin.push(response.data.getLoginDateReport.user[i].login_counter)
               todayloginName.push(response.data.getLoginDateReport.user[i].users.fname + ' ' + response.data.getLoginDateReport.user[i].users.lname)
             }

             this.todayLogin = [{name: 'Logins#', data: todaylogin}]
             this.fullname = todayloginName
           }
         }
        })
        .catch(error => {
        });

  },
  GetWeekReport(date){
    this.$apollo
       .mutate({
          mutation: GET_LOGIN_WEEK_REPORT,
           variables: {
            date: date,
          }
        }).then(response => {

      this.WeekDates = response.data.getLoginWeekReport.data.lables
      this.WeekLoginCount = response.data.getLoginWeekReport.data.values

    }).catch(error => {
        });
  }
  },
  created () {
    var today = new Date()
    var setcurrentDayDate =today.toISOString();

    var setLastMonthDate =today.setDate(today.getDate() - 30);
    var lastMonthDate = new Date(setLastMonthDate).toISOString();

    this.toDate = setcurrentDayDate;
    this.fromDate = lastMonthDate
    this.GetReport(today);
    this.GetWeekReport(today);

  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
